document.addEventListener('DOMContentLoaded', function() {

const search = document.getElementById('tatvamasi-search');

if(!search) return;

const texts = [
'Search Rudraksha',
'Search Pyrite',
'Search Money Magnet',
'Search Love / Wealth / Positivity',
'Find Your Spiritual Companion...'
];

let textIndex = 0;
let charIndex = 0;
let deleting = false;

function animatePlaceholder(){

const current = texts[textIndex];

if(!deleting){
search.placeholder = current.substring(0,charIndex++);
if(charIndex > current.length){
deleting = true;
setTimeout(animatePlaceholder,1200);
return;
}
}else{
search.placeholder = current.substring(0,charIndex--);
if(charIndex < 0){
deleting = false;
textIndex = (textIndex + 1) % texts.length;
}
}

setTimeout(animatePlaceholder,deleting ? 40 : 80);
}

animatePlaceholder();

});